import './styles.css';

const Section = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => (
  <div className="section-wrapper">
    <h2 className="section-heading">{title}</h2>
    <div className="section-box">{children}</div>
  </div>
);

export default Section;